<template>
  <section>
    <div class="goclsa">
      <div class="goclsaflex"></div>
      <div class="goclsalef" @click="gopage()">返回</div>
    </div>
    <div class="container" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="zhuti">
        <div v-for="(item, index) in this.abc" :key="index" v-if="item.type == 1">
          <div class="hhh">
            <div class="sss">
              <!-- 题目展示 -->
              <div class="subject">
                <span>{{ index + 1 }}.</span>
                <span v-html="item.title" :id="item.title"></span>
              </div>
            </div>
            <!-- 选择区域 -->
            <div>
              <ul>
                <li
                  v-for="(items, indexs) in item.answer"
                  :key="indexs"
                  @click="radioChange(index, indexs, item)"
                >
                  <label :for="item.Id" class="xz-label">
                    <input
                      type="radio"
                      v-model="item.value"
                      :value="items.Id"
                      @change="radioChange(index, indexs, item)"
                      :id="item.Id"
                      style=" margin-right: 10px;"
                      :disabled="Status"
                    />
                    {{ items.Name }}
                  </label>
                </li>
              </ul>
            </div>
            <div class="answer" v-if="Status == true">
              <div v-for="(items, indexs) in item.answer" :key="indexs" :id="items.Name">
                <span v-if="indexs == 0 && items.IsRight == true">正确答案：A</span>
                <span v-if="indexs == 1 && items.IsRight == true">正确答案：B</span>
                <span v-if="indexs == 2 && items.IsRight == true">正确答案：C</span>
                <span v-if="indexs == 3 && items.IsRight == true">正确答案：D</span>

                <span v-if="indexs == 0 && items.IsCheck == true">你选择的答案：A</span>
                <span v-if="indexs == 1 && items.IsCheck == true">你选择的答案：B</span>
                <span v-if="indexs == 2 && items.IsCheck == true">你选择的答案：C</span>
                <span v-if="indexs == 3 && items.IsCheck == true">你选择的答案：D</span>
              </div>
              <div style="margin-left: 40px">
                <span v-if="item.value == ''">你选择的答案：未作答</span>
              </div>
            </div>
            <div class="analysis" v-if="Status == true">
              <span>解析：{{ item.explain }}</span>
            </div>
          </div>
        </div>

        <div v-for="(item, index1) in this.abc" :key="index1" v-if="item.type == 2">
          <div class="hhh">
            <div class="sss">
              <!-- <div :id="item.title">{{ index1 + 1 }}.{{ item.title }}</div> -->
              <div class="subject">
                <span>{{ index1 + 1 }}.</span>
                <span v-html="item.title" :id="item.title"></span>
              </div>
            </div>
            <div>
              <ul>
                <li v-for="(items, indexs1) in item.answer" :key="indexs1" :id="items.Name">
                  <label :for="item.Id" class="xz-label">
                    <input
                      type="checkbox"
                      v-model="items.IsCheck"
                      :value="items.Id"
                      @change="checkboxChange(index1, indexs1, item)"
                      style="margin-right: 10px;"
                      :id="item.Id"
                      :disabled="Status"
                    />
                    {{items.Name}}
                  </label>
                </li>
              </ul>
            </div>
            <div class="answer" v-if="Status == true">
              <div class="rightanswer">
                <div>正确答案：</div>
                <div v-for="(items, indexs) in item.answer" :key="indexs">
                  <span v-if="indexs == 0 && items.IsRight == true">A</span>
                  <span v-if="indexs == 1 && items.IsRight == true">B</span>
                  <span v-if="indexs == 2 && items.IsRight == true">C</span>
                  <span v-if="indexs == 3 && items.IsRight == true">D</span>
                </div>
              </div>
              <div class="mychange">
                <div v-if="item.MyCate != ''">我选择的答案：</div>
                <div v-for="(aaa, bbb) in item.CheckAnswer" :key="bbb">
                  <span v-if="aaa.Value == 1">A</span>
                  <span v-if="aaa.Value == 2">B</span>
                  <span v-if="aaa.Value == 3">C</span>
                  <span v-if="aaa.Value == 4">D</span>
                </div>
              </div>
              <div class="mychange" v-if="item.MyCate == ''">
                <span>我选择的答案：未作答</span>
              </div>
            </div>
            <div class="analysis" v-if="Status == true">
              <span>解析：{{ item.explain }}</span>
            </div>
          </div>
        </div>
        <div v-for="(item, index2) in this.abc" :key="index2" v-if="item.type == 3">
          <div class="hhh">
            <div class="sss">
              <!-- <div :id="item.title">{{ index2 + 1 }}.{{ item.title }}</div> -->
              <div class="subject">
                <span>{{ index2 + 1 }}.</span>
                <span v-html="item.title" :id="item.title"></span>
              </div>
            </div>
            <div style="padding-left: 35px; line-height: 50px">
              <label :for="item.Id" class="xz-label">
                <input
                  :id="item.Id"
                  :name="item.id"
                  type="radio"
                  @change="dui(index2, item)"
                  style="margin-right: 10px"
                  :disabled="Status"
                />
                对
              </label>

              <label class="xz-label" :for="item.Id">
                <input
                  :id="item.Id"
                  :name="item.id"
                  type="radio"
                  @change="cuo(index2, item)"
                  style="margin-right: 10px"
                  :disabled="Status"
                />
                错
              </label>
            </div>
            <div class="answer" v-if="Status == true">
              <div v-for="(items, indexs) in item.answer" :key="indexs" :id="items.Name">
                <span v-if="items.IsRight == true">正确答案：正确</span>
                <span v-if="items.IsRight == false">正确答案：错误</span>
              </div>
              <div style="margin-left: 40px">
                <span v-if="item.value == ''">你选择的答案：未作答</span>
              </div>
            </div>
            <div class="analysis" v-if="Status == true">
              <span>解析：{{ item.explain }}</span>
            </div>
          </div>
        </div>
        <div v-for="(item, index3) in this.abc" :key="index3" v-if="item.type == 4">
          <div class="hhh">
            <div class="sss">
              <div class="subject">
                <span>{{ index3 + 1 }}.</span>
                <span v-html="item.title" :id="item.title"></span>
              </div>
            </div>
            <div>
              <el-input
                v-for="(items, indexs2) in item.answer"
                @paste.native.capture.prevent="handlePaste"
                :key="indexs2"
                v-model="items.letter"
                type="textarea"
                :rows="4"
                v-on:input="inputChange(index3, indexs2, item)"
                placeholder="请输入内容"
                style="
                  width: 95%;
                  padding-left: 30px;
                  padding-top: 10px;
                  padding-bottom: 20px;
                "
                :disabled="Status"
              ></el-input>
            </div>
            <div class="answer" v-if="Status==true">
              <div
                v-for="(items, indexs) in item.answer"
                :key="indexs"
                :id="items.Name"
                class="right-key"
              >
                <span class="select-keys">正确答案：{{ items.Name }}</span>
                <span class="tx-keys" style="margin-left:30px">
                  你填写的答案：{{
                  items.letter == "" ? "无" : items.letter
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(item, index4) in this.abc" :key="index4" v-if="item.type == 5">
          <div class="hhh">
            <div class="sss">
              <!-- <div :id="item.title">{{ index4 + 1 }}.{{ item.title }}</div> -->
              <div class="subject">
                <span>{{ index4 + 1 }}.</span>
                <span v-html="item.title" :id="item.title"></span>
              </div>
            </div>
            <div>
              <el-input
                v-for="(items, indexs2) in item.answer"
                @paste.native.capture.prevent="handlePaste"
                :key="indexs2"
                v-model="items.letter"
                v-on:input="inputChange(index4, indexs2, item)"
                placeholder="请输入内容"
                style="
                  width: 95%;
                  padding-left: 30px;
                  padding-top: 10px;
                  padding-bottom: 20px;
                "
                :disabled="Status"
              >
                <template slot="prepend">{{ indexs2 + 1 }}</template>
              </el-input>
            </div>
            <div class="answer" v-if="Status == true">
              <div
                v-for="(items, indexs) in item.answer"
                :key="indexs"
                :id="items.Name"
                style="width: 40%"
              >
                <span style="margin-left: 20px;">正确答案：{{ items.Name }}</span>
              </div>
            </div>
            <div class="analysis" v-if="Status == true">
              <span>解析：{{ item.explain }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 答题卡 -->

      <div class="tj">
        <el-button type="primary" class="sumbtbtns" @click="btnSubmit">提交</el-button>
      </div>
    </div>
  </section>
</template>

<script>
import * as studyClassIndex from '@/api/studyClass/index';
export default {
  props: ['Id'],
  data() {
    return {
      //弹框提示信息
      inforText: '',
      Status: false,
      abc: [],
      // Id: this.$route.query.id,
      allSum: 0,
      Status: false,

      ExamDetail: [],
      date: null,
      ExamStatus: true,
      loading: false, //遮罩层

      show: false, //vue动画加载
      hr: 0,
      mins: 0,
      sec: 0,
      customColor: '#409eff',
      paperPercentage: 0,
      arr: [],
    };
  },
  methods: {
    //点击提交按钮
    btnSubmit() {
      this.loadings();
      // console.log(this.abc);
    },

    getList() {
      let para = {
        id: this.Id,
      };
      studyClassIndex.GetLearnLists(para).then((res) => {
        // console.log(res.result);
        for (let i = 0; i < res.result.length; i++) {
          res.result[i].answer = JSON.parse(res.result[i].answer);
          res.result[i].bjStatus = false;
          res.result[i].MyCate = false;
          res.result[i].value = '';
          res.result[i].CheckAnswer = [];
          if (res.result[i].type == 5) {
            for (let index = 0; index < res.result[i].answer.length; index++) {
              res.result[i].answer[index].letter = '';
            }
          } else if (res.result[i].type == 4) {
            for (let index = 0; index < res.result[i].answer.length; index++) {
              res.result[i].answer[index].letter = '';
            }
          }
        }
        this.abc = res.result;
        this.allSum = this.abc.length;
      });
    },

    radioChange(index, indexs, item) {
      this.abc[index].answer.map((v, i) => {
        if (i == indexs) {
          v.IsCheck = true;
          this.abc[index].MyCate = true;

          this.abc[index].CheckAnswer = {
            QuestionId: item.id,
            Value: indexs + 1,
          };
        } else {
          v.IsCheck = false;
          this.abc[index].MyCate = true;

          this.abc[index].CheckAnswer = {
            QuestionId: item.id,
            Value: indexs + 1,
          };
        }
      });
    },
    checkboxChange(index, indexs, item) {
      if (this.abc[index].answer[indexs].IsCheck == true) {
        this.abc[index].MyCate = true;
        this.abc[index].CheckAnswer.push({
          QuestionId: item.id,
          Value: indexs + 1,
        });
      } else if (this.abc[index].answer[indexs].IsCheck == false) {
        this.abc[index].CheckAnswer.splice(indexs, 1);
      }
      if (this.abc[index].CheckAnswer.length == 0) {
        this.abc[index].MyCate = false;
      }
    },
    dui(index, item) {
      this.abc[index].answer[0].IsCheck = true;
      this.abc[index].CheckAnswer = { QuestionId: item.id, Value: 'true' };
      this.abc[index].MyCate = true;

      this.$refs.left.Selected(index, 0, item);
    },
    cuo(index, item) {
      this.abc[index].answer[0].IsCheck = false;
      this.abc[index].CheckAnswer = { QuestionId: item.id, Value: 'false' };
      this.abc[index].MyCate = true;

      this.$refs.left.Selected(index, 0, item);
    },
    inputChange(index, indexs, item) {
      for (let i = 0; i < this.abc[index].answer.length; i++) {
        if (this.abc[index].answer[i].letter != '') {
          this.abc[index].MyCate = true;
        } else if (this.abc[index].answer[i].letter == '') {
          this.abc[index].MyCate = false;
        }
      }
    },
    biaoji(item, index) {
      if (item.bjStatus == 0) {
        item.bjStatus = true;
        this.$refs.left.bj(item, index);
        this.$message({
          type: 'success',
          message: '已标记!',
        });
      } else {
        item.bjStatus = false;
        this.$refs.left.bj(item, index);
        this.$message({
          type: 'success',
          message: '取消标记!',
        });
      }
    },
    //动画加载,提交后显示分数
    loadings() {
      let _this = this;

      let flag = 0;

      for (let k = 0; k < _this.abc.length; k++) {
        if (_this.abc[k].type == 1) {
          for (let j = 0; j < _this.abc[k].answer.length; j++) {
            if (
              _this.abc[k].answer[j].IsRight == true &&
              _this.abc[k].answer[j].IsCheck == true
            ) {
              _this.abc[k].IsRight = true;
            } else {
              _this.abc[k].IsRight = false;
            }
          }
        } else if (_this.abc[k].type == 2) {
          if (flag > 0) {
            //如果正确答案数量和答对的选项个数相等,就加分,否则不加
            _this.abc[k].IsRight = false;
          } else {
            _this.abc[k].IsRight = true;
          }
        } else if (this.abc[k].type == 3) {
          for (let j = 0; j < this.abc[k].answer.length; j++) {
            if (
              this.abc[k].answer[j].IsRight == this.abc[k].answer[j].IsCheck
            ) {
              this.abc[k].IsRight = true;
            } else {
              this.abc[k].IsRight = false;
            }
          }
        } else if (this.abc[k].type == 4) {
          for (let j = 0; j < this.abc[k].answer.length; j++) {
            if (this.abc[k].answer[j].letter == this.abc[k].answer[j].Name) {
              this.abc[k].IsRight = true;
            } else {
              this.abc[k].IsRight = false;
            }
          }
        }

        console.log(this.abc);
        this.Status = true;
      }
    },
    // 返回上一页
    gopage() {
      let val = 1;
      this.$emit('Close', val);
    },
  },
  created() {
    //获取当前时间
    this.getList();
  },

  destroyed() {
    // this.aaa();
  },
};
</script>

<style scoped>
.container {
  width: 100%;
}
.zhuti {
  background-color: white;
  margin-top: 20px;
  /* border-bottom: 1px solid rgb(226, 223, 223); */
  border-radius: 5px;
}
.title {
  width: 100%;
  height: 40px;
  padding-top: 15px;
  font-size: 18px;
  background-color: #fafafa;
  border-left: 1px dashed rgb(226, 223, 223);
  border-right: 1px dashed rgb(226, 223, 223);
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-top: 1px dashed rgb(226, 223, 223);
}
li {
  padding-left: 40px;
  list-style: none;
  font-size: 30px;
  padding-bottom: 15px;
}
.leftzj {
  position: absolute;
  left: 15%;
  top: 498px;
}
.tj {
  display: flex;
  justify-content: flex-start;
}
.sumbtbtns {
  margin-left: auto;
}

.fixed {
  position: fixed;
  left: 15%;
  top: 10px;
}
.icon {
  width: 1em;
  height: 1em;
  font-size: 20px;
}
.icons {
  width: 1em;
  height: 1em;
  font-size: 15px;
}
.bj {
  background-color: #1a8cfe;
}
.sss {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin-left: 20px;
  margin-right: 20px;
}
.hhh {
  border: 1px solid rgb(226, 223, 223);
  margin-top: 20px;
  margin-bottom: 20px;
  padding-top: 20px;
}
.answer {
  display: flex;
  width: 92%;
  margin-left: 4%;
  border-top: 1px dashed rgb(226, 223, 223);
  line-height: 40px;
}
.analysis {
  width: 92%;
  margin-left: 4%;
  border-top: 1px dashed rgb(226, 223, 223);
  line-height: 40px;
}
.mychange {
  display: flex;
  width: 150px;
}
.rightanswer {
  display: flex;
  width: 150px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.progress {
  z-index: 2000;
  text-align: center;
  position: fixed;
  left: 39.5%;
  top: 35%;
  height: 250px;
  width: 400px;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  background-color: #fafafa;
}
.subject {
  display: flex;
  align-items: baseline;
}
.xz-label {
  font-size: 15px;
  display: flex;
  width: 100%;
  height: 30px;
  align-items: center;
}
.xz-label:hover {
  background-color: whitesmoke;
}
.paper-time {
  width: 120px;
  height: 50px;
  line-height: 25px;
  border-bottom: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  text-align: center;
  padding: 10px 0;
}
.red-color {
  color: red;
  font-size: 18px;
}
.paper-box {
  display: flex;
  flex-direction: column;
  position: fixed;
  right: 100px;
  bottom: 480px;
  width: 120px;
  height: 200px;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  text-align: center;
  padding: 10px 0;
}
.paper-progress {
  display: flex;
  flex-direction: column;
  line-height: 30px;
  height: 80px;
  border-bottom: 1px solid rgb(226, 223, 223);
  padding: 10px 0;
}
.goclsa {
  height: 30px;
  line-height: 30px;
  width: 100%;
  display: flex;
}
.goclsaflex {
  flex: 1;
}
.goclsalef {
  text-align: right;
  color: #00c758;
  font-weight: bold;
  font-size: 14px;
}
</style>